export const QUICK_REACTIONS = ['🎉', '👀', '✅', '🙏', '🔥', '💜'];
